import { LocalizedTranslations } from '../localizedTranslations';

export const de: LocalizedTranslations = {
  // Navigation
  nav: {
    home: 'Startseite',
    europeanMarkets: 'Europäische Märkte',
    aboutUs: 'Über Uns',
    products: 'Produkte',
    oemSolutions: 'OEM-Lösungen',
    blog: 'Blog',
    clientHub: 'Kundenportal',
    agentLogin: 'Agentenanmeldung',
    contact: 'Kontakt',
    getStarted: 'Jetzt Starten',
    smartToilets: 'Smarte Toiletten',
    businessSolutions: 'Geschäftslösungen',
    technology: 'Technologie',
    about: 'Über Uns',
    viewAllProducts: 'Alle Produkte Anzeigen',
    flagship: 'Flaggschiff',
    productDescriptions: {
      rem7: 'Unsere Premiere Smart-Toilette',
      luxa: 'Ultimative Luxuslinie',
      luna: 'Kompakt Minimalistisch',
      nova: 'Familien Smart-Toilette',
      aria: 'Öko-Luxus Design',
      vena: 'Premium Bidet',
      aurelius: 'Klassische Eleganz',
      aurelux: 'Goldakzent Edition',
      luma: 'Smarte Innovation',
    },
  },
  
  // Common
  common: {
    learnMore: 'Mehr Erfahren',
    viewDetails: 'Details Anzeigen',
    requestQuote: 'Angebot Anfordern',
    downloadCatalog: 'Katalog Herunterladen',
    contactUs: 'Kontaktieren Sie Uns',
    readMore: 'Weiterlesen',
    seeAll: 'Alle Anzeigen',
    back: 'Zurück',
    next: 'Weiter',
    previous: 'Zurück',
    submit: 'Absenden',
    send: 'Senden',
    close: 'Schließen',
    loading: 'Laden...',
    error: 'Fehler',
    success: 'Erfolg',
  },
  
  // Homepage
  home: {
    heroTitle: 'Premium Smarte Toiletten für Europäische Märkte',
    heroSubtitle: 'Erleben Sie die Zukunft des Badezimmerluxus mit intelligentem Design und modernster Technologie',
    exploreCollection: 'Kollektion Entdecken',
    watchVideo: 'Video Ansehen',
    featuredProducts: 'Ausgewählte Produkte',
    whyChooseUs: 'Warum Aureum VII Trading Wählen',
    testimonials: 'Was Unsere Kunden Sagen',
    certifications: 'Zertifizierungen & Standards',
  },
  
  // Products
  products: {
    title: 'Unsere Smarte Toiletten Kollektion',
    subtitle: 'Entdecken Sie unsere Reihe an Premium intelligenten Badezimmerlösungen',
    features: 'Eigenschaften',
    specifications: 'Technische Daten',
    installation: 'Installationsanleitung',
    warranty: 'Garantieinformationen',
    dimensions: 'Abmessungen',
    waterUsage: 'Wasserverbrauch',
    powerConsumption: 'Stromverbrauch',
    weight: 'Gewicht',
    material: 'Material',
    certification: 'Zertifizierung',
    relatedProducts: 'Verwandte Produkte',
  },
  
  // Contact
  contact: {
    title: 'Kontaktieren Sie Uns',
    subtitle: 'Wir freuen uns von Ihnen zu hören. Senden Sie uns eine Nachricht und wir werden so schnell wie möglich antworten.',
    name: 'Vollständiger Name',
    email: 'E-Mail-Adresse',
    phone: 'Telefonnummer',
    company: 'Firmenname',
    message: 'Ihre Nachricht',
    sendMessage: 'Nachricht Senden',
    ourLocation: 'Unser Standort',
    emailUs: 'E-Mail an Uns',
    callUs: 'Rufen Sie Uns An',
    businessHours: 'Geschäftszeiten',
    weekdays: 'Montag - Freitag: 9:00 - 18:00 Uhr',
    weekend: 'Samstag - Sonntag: Geschlossen',
  },
  
  // About
  about: {
    title: 'Über Aureum VII Trading',
    subtitle: 'Ihr vertrauenswürdiger Partner für Premium smarte Toilettenlösungen in Europa',
    ourStory: 'Unsere Geschichte',
    ourMission: 'Unsere Mission',
    ourVision: 'Unsere Vision',
    ourValues: 'Unsere Werte',
    quality: 'Qualität',
    innovation: 'Innovation',
    sustainability: 'Nachhaltigkeit',
    customerFocus: 'Kundenorientierung',
  },
  
  // Footer
  footer: {
    description: 'Premium smarte Toilettenlösungen für den europäischen Markt. Erleben Sie Luxus, Innovation und Nachhaltigkeit.',
    quickLinks: 'Schnelllinks',
    products: 'Produkte',
    support: 'Support',
    legal: 'Rechtliches',
    privacyPolicy: 'Datenschutzrichtlinie',
    termsConditions: 'Allgemeine Geschäftsbedingungen',
    returnPolicy: 'Rückgaberichtlinie',
    shippingPolicy: 'Versandrichtlinie',
    allRightsReserved: 'Alle Rechte vorbehalten.',
    followUs: 'Folgen Sie Uns',
  },
  
  // Forms
  forms: {
    required: 'Dieses Feld ist erforderlich',
    invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    invalidPhone: 'Bitte geben Sie eine gültige Telefonnummer ein',
    messageSent: 'Ihre Nachricht wurde erfolgreich gesendet!',
    errorSending: 'Beim Senden Ihrer Nachricht ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  },
  
  // FAQ
  faq: {
    title: 'Häufig Gestellte Fragen',
    subtitle: 'Finden Sie Antworten auf häufige Fragen zu unseren smarten Toiletten',
    stillHaveQuestions: 'Haben Sie noch Fragen?',
    contactSupport: 'Kontaktieren Sie unser Support-Team',
  },
  
  // Blog
  blog: {
    title: 'Neueste Artikel',
    subtitle: 'Bleiben Sie über die neuesten Trends in der smarten Badezimmertechnologie informiert',
    readingTime: 'Min. Lesezeit',
    author: 'Von',
    publishedOn: 'Veröffentlicht am',
    categories: 'Kategorien',
    tags: 'Schlagwörter',
    relatedArticles: 'Verwandte Artikel',
  },
  
  // Meta/SEO
  meta: {
    homeTitle: 'REM7 Smart-Toilette Spanien | Aureum VII Trading',
    homeDescription: 'Entdecken Sie die REM7 Smart-Toilette, die in Spanien eingeführt wird. Private Vorführung oder Projektpreise bei Aureum VII Trading anfragen.',
    productsTitle: 'Smart-Toiletten-Kollektion | Aureum VII Trading',
    productsDescription: 'Entdecken Sie LUXA, LUNA, NOVA, ARIA und die gesamte REM7-Serie: Premium-Smart-Toiletten mit Bidet, Heizung und UV-Sterilisation für europäische Luxushaushalte.',
    contactTitle: 'Kontakt | Aureum VII Trading',
    contactDescription: 'Kontaktieren Sie Aureum VII Trading für ein Angebot, eine Geschäftsanfrage oder Fragen zu unseren Smart-Toiletten.',
    aboutTitle: 'Über Uns | Aureum VII Trading',
    aboutDescription: 'Aureum VII Trading (REM7) entwickelt Premium-Smart-Toiletten für europäische Luxushaushalte — fortschrittliche Technik trifft europäische Handwerkskunst.',
    defaultTitle: 'Aureum VII Trading | Luxus-Smart-Toiletten Europa',
    defaultDescription: 'Premium intelligente Toiletten mit beheizten Sitzen, Bidet-Funktionen und Smart-Technologie. Europäische Qualität und Design.',
    rem7Title: 'REM7 — Das Flaggschiff-Smart-WC | Aureum VII Trading',
    rem7Description: 'REM7, die Flaggschiff-Smart-Toilette von Aureum VII Trading. Integriertes Bidet, Sofort-Heizung, UV-Sterilisation und Eco-Modus. Sonderangebot: 600 € pro Stück.',
    luxaTitle: 'LUXA — Luxuriöse Smart-Toilette | Aureum VII Trading',
    luxaDescription: 'LUXA verbindet europäisches Design mit fortschrittlicher Technik: Bidet mit einstellbarer Temperatur, LED-Nachtlicht und UV-Sterilisation. Sonderangebot: 600 € pro Stück.',
    bathSanitaryTitle: 'Luxus-Bad & Sanitär | Aureum VII Trading',
    bathSanitaryDescription: 'B2B-Katalog für Badewannen, Whirlpools, Waschbecken und Premium-Badmöbel. Mengenpreise für Hotels, Bauträger und Architekten in ganz Europa.',
    businessTitle: 'B2B-Lösungen für Hotels & Bauträger | Aureum VII Trading',
    businessDescription: 'Sondermengenpreise, OEM-Unterstützung und europaweite Logistik für Architekten, Hotels und Bauträger. Fordern Sie ein Geschäftsangebot an.',
    compareTitle: 'Smart-Toiletten-Modelle Vergleichen | Aureum VII Trading',
    compareDescription: 'Vergleichen Sie Funktionen, Preise und technische Daten aller REM7-Modelle direkt nebeneinander und finden Sie die passende Smart-Toilette.',
    faqTitle: 'Häufig Gestellte Fragen | Aureum VII Trading',
    faqDescription: 'Antworten zu Installation, Garantie, Wartung und Preisen der REM7-Smart-Toiletten. Alles Wichtige vor dem Kauf.',
  },
  
  // Product Pages
  productPages: {
    luna: {
      title: 'LUNA M9 Luxus-Smart-Toilette | Wellness-Spa-Technologie',
      description: 'Entdecken Sie die LUNA M9 Smart-Toilette mit Sofortheizung, digitalem Display, therapeutischer Spa-Reinigung und Wellness-Funktionen.',
      heroTitle: 'LUNA',
      heroSubtitle: 'Modell M9',
      heroDescription: 'Die LUNA M9 Luxus-Smart-Toilette verbindet zeitlose Eleganz mit fortschrittlicher Wellness-Funktionalität.',
      features: {
        heatedSeat: 'Beheizter Sitz mit Nachtlicht',
        washModes: 'Mehrere Waschmodi',
        dryingFunction: 'Intelligente Trocknungsfunktion',
        modernDesign: 'Schlankes modernes Design',
      },
      cta: {
        downloadSpec: 'Spezifikationen Herunterladen',
        backToCollections: '← Zurück zu Kollektionen',
        requestQuote: 'Angebot Anfordern',
      },
    },
    luxa: {
      title: 'LUXA M80 Flaggschiff-Smart-Toilette | Premium-Bidet-System',
      description: 'LUXA M80 Flaggschiff-Smart-Toilette mit Bewegungssensoren, tankloser Heizung, UV-Sterilisation und Premium-Automatisierung.',
      heroTitle: 'LUXA',
      heroSubtitle: 'Modell: M80',
      heroDescription: 'Die LUXA M80 ist das Flaggschiff unserer Premium-Kollektion und repräsentiert den Höhepunkt intelligenter Badezimmer-Innovation.',
      features: {
        motionSensor: 'Deckel mit Bewegungssensor',
        tanklessHeating: 'Tanklose Sofortheizung',
        adjustableTemp: 'Einstellbare Wassertemperatur & Druck',
        premiumCeramic: 'Premium-Keramik + Soft-Close-Deckel',
        ecoDesign: 'Umweltfreundliches Design',
      },
      cta: {
        downloadSpec: 'Spezifikationen Herunterladen',
        backToCollections: '← Zurück zu Kollektionen',
        requestQuote: 'Angebot Anfordern',
      },
    },
    aria: {
      title: 'ARIA H60 Wand-Smart-Toilette | Platzsparendes Design',
      description: 'ARIA H60 architektonische Wand-Smart-Toilette mit elegantem Design, fortschrittlicher Bidet-Technologie und platzsparender Installation.',
      heroTitle: 'ARIA',
      heroSubtitle: 'Modell H60',
      heroDescription: 'Die ARIA H60 betont minimalistisches architektonisches Design mit maximalem Komfort und intelligenter Funktionalität.',
      features: {
        bidetSpray: 'Einstellbarer Bidet-Strahl',
        waterSaving: 'Wasserspartechnologie',
        compactFit: 'Kompakte Passform für kleine Badezimmer',
        softClose: 'Soft-Close-Deckel',
      },
      cta: {
        downloadSpec: 'Spezifikationen Herunterladen',
        backToCollections: '← Zurück zu Kollektionen',
        requestQuote: 'Angebot Anfordern',
      },
    },
  },
};
